import { processAccordingPostType } from './processAccordingPostType';

export const typeToProcess = {
  'post-rate': (notification, processes) =>
    processAccordingPostType(notification.post || {}, {
      blog: processes.like,
      poll: processes.like,
      question: processes.like,
    }) || processes.likeReply,
  'user-follows': 'followUser',
  'post-follows': 'followPost',
  'user-mention': 'mention',
  'items': (notification, processes) =>
    processAccordingPostType(notification.post || {}, processes),
};

export function processAccordingNotificationType(notification = {}, processes = {}) {
  const processKey = typeToProcess[notification.type];
  return typeof processKey === 'function' ?
    processKey(notification, processes) :
    processes[processKey];
}



// WEBPACK FOOTER //
// ./~/virgo/src/utils/processAccordingNotificationType.js